import { render, staticRenderFns } from "./StartBreadView.vue?vue&type=template&id=06577528&"
import script from "./StartBreadView.vue?vue&type=script&lang=js&"
export * from "./StartBreadView.vue?vue&type=script&lang=js&"
import style0 from "./StartBreadView.vue?vue&type=style&index=0&id=06577528&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports